import React from 'react';
import {Drawer as MUIDrawer} from '@mui/material';

type TopNavMenu = {
  open: boolean;
  onClose: () => void;
  children: any;
  transparent: boolean;
};

const TopNavMenu: React.FC<TopNavMenu> = (props) => {
  return (
    <MUIDrawer
      PaperProps={{
        sx: props.transparent
          ? {
              backdropFilter: 'blur(10px)',
              backgroundColor: 'rgb(0, 0, 0, 0.3)',
              boxShadow: 'none',
            }
          : {
              boxShadow: 'none',
              background: '#2D2D2D',
            },
      }}
      anchor='top'
      open={props.open}
      variant='temporary'
      ModalProps={{
        keepMounted: false,
        slotProps: {
          backdrop: {
            sx: {
              backgroundColor: 'transparent',
            },
            onClick: props.onClose,
          },
        },
      }}>
      {props.children}
    </MUIDrawer>
  );
};
export default TopNavMenu;
export type {TopNavMenu};
